import { render, staticRenderFns } from "./MemoVersionsDialog.vue?vue&type=template&id=55a9f892&scoped=true"
import script from "./MemoVersionsDialog.vue?vue&type=script&lang=ts"
export * from "./MemoVersionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./MemoVersionsDialog.vue?vue&type=style&index=0&id=55a9f892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9f892",
  null
  
)

export default component.exports